<template>
    <div>
        <base-header class="pb-9 pt-3" type="danger">
        </base-header>
        <div class="container-fluid mt--8">
            <div class="row">
                <div class="col">
           
                    <div class="card">
                        <div class="card-body">
                            <div class="viewing-card">
                                <div class="viewer" v-if="file">
                                    <video-player
                                        ref="videoPlayer"
                                        class="archive-video-player"
                                        :playsinline="true"
                                        :options="playerOptions"
                                        @ready="onPlayerReady"
                                    ></video-player>
                                    <div class="container">
                                        <div class="row justify-content-md-center mt-2 mb-3">
                                            <div class="col-auto">
                                                <base-button type="secondary" size="sm" @click="jump(-30)"><i
                                                        class="fas fa-backward"></i>30s</base-button>
                                                <base-button type="secondary" size="sm" @click="jump(-5)"><i
                                                        class="fas fa-backward"></i>5s</base-button><base-button
                                                    type="secondary" size="sm" @click="jump(-1)"><i
                                                        class="fas fa-backward"></i>1s</base-button>
                                                <base-button type="secondary" size="sm" @click="jump(0.04)"><i
                                                        class="fas fa-backward"></i>1f</base-button>
                                                <base-button type="warning" size="sm" @click="pauseVideo"><i
                                                        class="fas fa-pause"></i></base-button>
                                                <base-button type="primary" size="sm" @click="playVideo(1)"><i
                                                        class="fas fa-play"></i></base-button> <base-button
                                                    type="primary" size="sm" @click="playVideo(2)"><i
                                                        class="fas fa-play">x2</i></base-button>
                                                <base-button type="primary" size="sm" @click="playVideo(5)"><i
                                                        class="fas fa-play">x5</i></base-button>
                                                <base-button type="secondary" size="sm" @click="jump(0.04)"><i
                                                        class="fas fa-forward"></i>1f</base-button>
                                                <base-button type="secondary" size="sm" @click="jump(1)"><i
                                                        class="fas fa-forward"></i>1s</base-button>
                                                <base-button type="secondary" size="sm" @click="jump(5)"><i
                                                        class="fas fa-forward"></i>5s</base-button>
                                                <base-button type="secondary" size="sm" @click="jump(30)"><i
                                                        class="fas fa-forward"></i>30s</base-button>
                                            </div>
                                        </div>
                                        <div class="row justify-content-md-center mb-5">
                                            <div class="col-3">
                                                <base-button type="secondary" block @click="setIn()"
                                                    v-if="!editEvent">Set In</base-button>
                                                <base-button block type="danger" @click="updateIn()" :disabled="isRangeEditLocked" v-else>Update
                                                    In</base-button>
                                            </div>
                                            <div class="col-3">
                                                <base-button type="secondary" block @click="setOut()"
                                                    v-if="!editEvent">Set Out</base-button>
                                                <base-button type="danger" block @click="updateOut()" :disabled="isRangeEditLocked" v-else>Update
                                                    Out</base-button>
                                            </div>
                                        </div>
                                        <div class="row justify-content-md-center mb-2" v-if="isRangeEditLocked">
                                            <div class="col-auto text-warning">
                                                You cannot edit In/Out while a clip is attached. Delete the associated clip first.
                                            </div>
                                        </div>
                                        <!-- new event -->
                                        <div class="row" v-if="!editEvent">
                                            <div class="col">
                                                <div class="row mb-3">
                                                    <div class="col-4" v-if="tcIn">
                                                        <base-button v-if="tcIn" block type="secondary"
                                                            @click="goToVideoTime(tcIn)">In: {{ timeIn }}</base-button>
                                                    </div>
                                                    <div class="col-4" v-if="tcOut">
                                                        <base-button v-if="tcOut" block type="secondary"
                                                            @click="goToVideoTime(tcOut)">Out: {{ timeOut
                                                            }}</base-button>
                                                    </div>

                                                    <!-- <div class="col">
                          <base-checkbox
                            type="default"
                            class="
                              form-control form-control-label
                              bookmarkOption
                            "
                            v-model="addTags"
                            >Add Tags</base-checkbox
                          >
                        </div> -->

                                                    <div class="col-4" v-if="tcIn && tcOut">
                                                        <base-button block type="success" @click="markIt">Mark
                                                            It</base-button>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="isSet">
                                                    <div class="col">
                                                        <base-input label="Tag Name">
                                                            <el-select v-model="bookmark" filterable allow-create
                                                                placeholder="Pick or write new">
                                                                <el-option v-for="option in bookmarkOptions"
                                                                    :key="option" :label="option" :value="option">
                                                                </el-option>
                                                            </el-select>
                                                        </base-input>
                                                    </div>
                                                    <div class="col">
                                                        <filter-selector :selection="playerSearchObj"
                                                            @valueChange="bookmarkPlayer = $event">
                                                        </filter-selector>
                                                    </div>
                                                    <div class="col">
                                                        <base-input label="Tag Team">
                                                            <el-select v-model="bookmarkTeam" filterable clearable
                                                                placeholder="Tag Team">
                                                                <el-option v-for="option in teams" :key="option.id"
                                                                    :label="option.teamName" :value="option.id">
                                                                </el-option>
                                                            </el-select>
                                                        </base-input>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="isSet">
                                                    <div class="col">
                                                        <base-input label="Clip Note" v-model="note">
                                                        </base-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- edit event -->
                                        <div class="row mb-4" v-else>
                                            <div class="col">
                                                <div class="row mb-3">
                                                    <div class="col-4">
                                                        <base-button block type="secondary"
                                                            @click="goToVideoTime(tcIn)">In: {{ timeIn }}</base-button>
                                                    </div>
                                                    <div class="col-4">
                                                        <base-button type="secondary" block
                                                            @click="goToVideoTime(tcOut)">Out: {{ timeOut
                                                            }}</base-button>
                                                    </div>

                                                    <div class="col-4">
                                                        <div @click="stopEdit()" class="btn btn-block">
                                                            <i class="fas fa-window-close mr-1"></i>Stop
                                                            Editing {{ editEvent.innings }}.{{
                                                                editEvent.over
                                                            }}.{{ editEvent.ballNum }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <base-input label="Tag Name">
                                                            <el-select v-model="editEvent.bookmark" filterable
                                                                placeholder="Pick or write new"
                                                                @change="changeEvent($event, 'bookmark')">
                                                                <el-option v-for="option in bookmarkOptions"
                                                                    :key="option" :label="option" :value="option">
                                                                </el-option>
                                                            </el-select>
                                                        </base-input>
                                                    </div>
                                                    <div class="col">
                                                        <filter-selector :selection="playerSearchObj" @valueChange="
                                                            changeEvent($event, 'bookmarkPlayer')
                                                            " :preValue="editEvent.bookmarkPlayer">
                                                        </filter-selector>
                                                    </div>
                                                    <div class="col">
                                                        <base-input label="Tag Team">
                                                            <el-select v-model="editEvent.bookmarkTeam" filterable
                                                                clearable @change="changeEvent($event, 'bookmarkTeam')"
                                                                placeholder="Tag Team">
                                                                <el-option v-for="option in teams" :key="option.id"
                                                                    :label="option.teamName" :value="option.id">
                                                                </el-option>
                                                            </el-select>
                                                        </base-input>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <base-input label="Clip Note" v-model="editEvent.note"
                                                            @change="changeEvent($event.target.value, 'note')">
                                                        </base-input>
                                                    </div>
                                                </div>
                                                <div class="row align-items-center">
                                                    <div class="col-auto" v-if="editEventLive.clipped">
                                                        <download
                                                            :fileID="editEventFile && editEventFile.id"
                                                            :gated="true"
                                                            label="Download"
                                                            btn-class="btn"
                                                        ></download>
                                                    </div>
                                                    <div class="col-auto" v-if="showSourceClipPreviewLink">
                                                        <a class="btn" :href="editEventFile.previewDownloadURL" target="_blank" rel="noopener">
                                                            <i class="fas fa-play mr-2"></i>Play MP4 Preview
                                                        </a>
                                                    </div>
                                                    <div class="col-auto" v-if="showSourceClipPreviewPending">
                                                        Source MXF clip is download-only while MP4 preview transcodes.
                                                    </div>
                                                    <div class="col-auto"
                                                        v-if="editEventLive.clipStatus === 'clipping'">
                                                        Clipping In Progress
                                                        <div v-if="currentClipRequest && currentClipRequest.progress">
                                                            <div class="clip-progress mt-1">
                                                                <div
                                                                    class="clip-progress-fill"
                                                                    :style="{ width: currentClipRequestProgressPercent + '%' }"
                                                                ></div>
                                                            </div>
                                                            <small>
                                                                {{ currentClipRequestProgressPercent }}%
                                                                <span v-if="currentClipRequest.progress.timemark">
                                                                    ({{ currentClipRequest.progress.timemark }})
                                                                </span>
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <div class="col-auto"
                                                        v-if="!editEventLive.clipped && editEventLive.clipStatus != 'clipping'">
                                                        <base-input class="mb-0">
                                                            <el-select v-model="clipProfile" placeholder="Clip Quality">
                                                                <el-option v-for="option in clipProfileOptions"
                                                                    :key="option.value" :label="option.label"
                                                                    :value="option.value">
                                                                </el-option>
                                                            </el-select>
                                                        </base-input>
                                                    </div>
                                                    <div class="col-auto"
                                                        v-if="!editEventLive.clipped && editEventLive.clipStatus != 'clipping'">
                                                        <div @click="clipIt()" class="btn btn-primary" :class="{ disabled: isClipDurationOverLimit }">
                                                            Clip It
                                                        </div>
                                                    </div>
                                                    <div class="col-auto text-warning" v-if="isClipDurationOverLimit">
                                                        Clip length exceeds {{ maxClipMinutes }} minutes for {{ matchType }} matches. Please select a shorter range.
                                                    </div>
                                                    <div class="col-auto" v-if="showClipProfileBadge">
                                                        <span class="badge badge-info">
                                                            {{ clipProfileBadgeLabel }}
                                                        </span>
                                                    </div>
                                                    <div class="col-auto" v-if="
                                                        editEvent.source === 'user' &&
                                                        editEventLive.clipStatus != 'clipping'
                                                    ">
                                                        <base-button default @click="deleteEvent">Delete
                                                            Clip</base-button>
                                                    </div>
                                                    <div class="col" v-if="editEvent.source === 'user'">
                                                        Marked by: {{ editEventLive.username }}
                                                    </div>
                                                </div>
                                                <div class="row align-items-center mt-2" v-if="editEventLive.clipped && canAddToCollections">
                                                    <div class="col-auto">
                                                        <base-input class="mb-0">
                                                            <el-select
                                                                v-model="selectedCollectionId"
                                                                filterable
                                                                clearable
                                                                placeholder="Choose collection"
                                                            >
                                                                <el-option
                                                                    v-for="col in collections"
                                                                    :key="col.id"
                                                                    :label="col.name"
                                                                    :value="col.id"
                                                                >
                                                                </el-option>
                                                            </el-select>
                                                        </base-input>
                                                    </div>
                                                    <div class="col-auto">
                                                        <base-button
                                                            type="default"
                                                            :disabled="!selectedCollectionId || addingToCollection || clipAlreadyInSelectedCollection"
                                                            @click="addToCollection"
                                                        >
                                                            {{ addingToCollection ? "Adding..." : "Add to Collection" }}
                                                        </base-button>
                                                    </div>
                                                    <div class="col-auto small text-muted" v-if="editEventCollectionNames.length">
                                                        In collections: {{ editEventCollectionNames.join(", ") }}
                                                    </div>
                                                </div>
                                                <div class="row align-items-center mt-2" v-else-if="editEventLive.clipped && editEventCollectionNames.length">
                                                    <div class="col-auto small text-muted">
                                                        In collections: {{ editEventCollectionNames.join(", ") }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="events">
                                    <div class="col event-controls">
                                        <div class="row align-items-center mb-2">
                                            <div class="col">
                                                <div class="form-group row mb-0">
                                                    <label class="col-auto form-control-label">Deliveries:</label>
                                                    <div class="col">
                                                        <base-switch type="default" v-model="showDeliveries">
                                                        </base-switch>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <base-input>
                                                    <el-select v-model="userFilter" filterable clearable multiple placeholder="Clipped By">
                                                        <el-option v-for="option in clippedBy" :key="option" :label="option"
                                                            :value="option">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <div class="col">
                                                <base-input>
                                                    <el-select v-model="bookmarkFilter" filterable clearable multiple
                                                        placeholder="Tag Filter">
                                                        <el-option v-for="option in bookmarksAvailable" :key="option" :label="option"
                                                            :value="option">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                        </div>
                                        <div class="row align-items-center" v-if="showDeliveries">
                                            <div class="col">
                                                <base-input>
                                                    <el-select v-model="optaFilter" multiple clearable placeholder="Delivery Filters">
                                                        <el-option v-for="option in optaFilters" :key="option.value" :label="option.label"
                                                            :value="option.value">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <div class="col">
                                                <base-input>
                                                    <el-select v-model="displayFields" @change="displayFieldsSet($event)"
                                                        filterable multiple placeholder="Timeline Options">
                                                        <el-option v-for="option in displayOptions" :key="option.field"
                                                            :label="option.label" :value="option.field">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                        </div>
                                    </div>
                                    <ul class="list-group list-group-flush list event-list">
                                        <li v-for="event in events" class="list-group-item px-0" :key="event.in">
                                            <event :event="event" :currentEditEvent="editEvent && editEvent.id ? editEvent.id : ''"
                                                @jumpTo="goToVideoTime(event.tcIn)" @select="edit(event)" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
               <div class="col" v-if="user.roles.archive_uploader">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="mb-0">File Info</h3>
                        </div>
                        <div class="card-body" v-if="file">
           
                             <div v-if="file.metadata">
                                Timecode Start: {{ file.metadata.timecodeStart }}
                            </div>
                            <base-button @click="reassociate()">Associate file with new match</base-button>
              
                            <base-input
                    label="Part"
                    v-model="file.part"
                @change="changeField($event.target.value, 'part')"
                  />    
                        </div>
                    </div>
                </div> 


                 <!-- <div class="col">
          <div class="card">
            <div class="card-header">
              <h3 class="mb-0">Recordings of this match</h3>
            </div>
            <div class="card-body">
              <ul v-if="recordings.length > 0">
                <li v-for="recording in recordings">
                  <router-link class="btn btn-sm" :to="'/recording/' + recording.id">Day: {{recording.day}}, Part: {{ recording.part }}</router-link>
                </li>
              </ul>

            </div>
          </div>
        </div>  -->

            </div>
        </div>
    </div>

</template>

<script>
import VideoEventDisplay from "./Components/VideoEventDisplay";
import FilterSelector from "./Components/FilterSelector";
import Download from "./Components/Download";
import { getMaxClipMinutes } from "@/utils/companyLimits";

import moment from "moment";
export default {
    components: {
        event: VideoEventDisplay,
        "filter-selector": FilterSelector,
        download: Download,
    },
    name: "archive-video-viewer",
    data() {
        return {
            playerSearchObj: {
                index: "players",
                searchField: "fullName",
                label: "Tag Player",
                type: "single-search",
            },
            selectedCollectionId: "",
            addingToCollection: false,
            tcIn: "",
            tcOut: "",
            editEvent: "",
            showDeliveries: true,
            bookmarkFilter: [],
            userFilter: [],
            optaFilter: ["boundaries", "wicket"],
            optaFilters: [
                { label: "Wickets", value: "wicket" },
                { label: "Runs", value: "runs" },
                { label: "Boundaries", value: "boundaries" },
                { label: "Extras", value: "extras" },
            ],
            bookmark: "",
            bookmarkPlayer: "",
            bookmarkTeam: "",
            note: '',
            clipProfile: "source",
            markerRenderScheduled: false,
        };
    },
    computed: {
        recordings() {
            var arr = this.$store.getters["files/recordingsByMatch"](this.match.id);
            return arr.sort(function (a, b) {
                var keyA1 = parseInt(a.day),
                    keyA2 = parseInt(a.part),
                    keyB1 = parseInt(b.day),
                    keyB2 = parseInt(b.part);

                // Compare the 2 keys
                if (keyA1 < keyB1) return -1;
                if (keyA1 > keyB1) return 1;
                if (keyA2 < keyB2) return -1;
                if (keyA2 > keyB2) return 1;
                return 0;
            });
        },
        bookmarkOptions() {
            return this.$store.getters["archiveTemp/bookmarkOptions"];
        },
        fileId() {
            return this.$route.params.id;
        },
        isSet() {
            if (this.tcIn && this.tcOut) {
                return true;
            }
        },
        bookmarksAvailable() {
            var all = this.$store.getters["archiveEvents/array"];
            var newArr = [];
            all.forEach((event) => {
                if (event.bookmark) {
                    if (!newArr.includes(event.bookmark)) newArr.push(event.bookmark);
                }
            });
            return newArr;
        },
        clippedBy() {
            var all = this.$store.getters["archiveEvents/array"];
            var newArr = [];
            all.forEach((event) => {
                if (event.source === "user") {
                    if (!newArr.includes(event.username)) newArr.push(event.username);
                }
            });
            return newArr;
        },
        eventsObj() {
            return this.$store.getters["archiveEvents/obj"];
        },
        events() {
            var all = this.$store.getters["archiveEvents/array"];
            var newArr = [];
            all.forEach((event) => {
                if (event.source === "user") {
                    if (this.userFilter.length > 0) {
                        if (this.userFilter.includes(event.username)) {
                            newArr.push(event);
                        }
                    } else {
                        newArr.push(event);
                    }
                }
                if (this.showDeliveries && event.source !== "user") {
                    if (this.optaFilter.length > 0) {
                        if (this.optaFilter.some((filterKey) => {
                            if (filterKey === "boundaries") {
                                const runs = Number(event.runs);
                                return Number.isFinite(runs) && runs >= 4;
                            }
                            return event[filterKey];
                        })) {
                            newArr.push(event);
                        }
                    } else {
                        newArr.push(event);
                    }
                }
            });
            if (this.bookmarkFilter.length > 0) {
                //if tag filter
                newArr = newArr.filter((event) =>
                    this.bookmarkFilter.includes(event.bookmark)
                );
            }
            return newArr.sort((a, b) => {
                if (a.tcIn < b.tcIn) {
                    return -1;
                }
                if (a.tcIn > b.tcIn) {
                    return 1;
                }
                if (!a.tcIn) {
                    return -1;
                }
                return 0;
            });
        },
        teams() {
            return this.$store.getters["teams/array"];
        },
        players() {
            return this.$store.getters["players/array"];
        },
        file() {
            return this.$store.getters["files/fileById"](this.fileId);
        },
        selectedClips() {
            var selects = this.$store.getters["archiveTemp/eventSelection"];
            var clips = [];
            selects.forEach((select) => {
                clips.push(this.eventsObj[select]);
            });
            return clips;
        },
        selectedClipLength() {
            return this.selectedClips.length;
        },
        selectedClipDuration() {
            var clips = this.selectedClips;
            var dur = 0;
            clips.forEach((select) => {
                dur = dur + (select.tcOut - select.tcIn);
            });
            return Math.floor(dur);
        },
        editEventLive() {
            if (!this.editEvent || !this.editEvent.id) return {};
            return this.$store.getters["archiveEvents/byId"](this.editEvent.id) || {};
        },
        editEventFile() {
            if (!this.editEventLive || !this.editEventLive.clipFile) return null;
            return this.$store.getters["files/fileById"](this.editEventLive.clipFile);
        },
        match() {
            var id = this.$store.getters["matches/byId"](this.file.match);
            if (id) {
                return id;
            } else {
                this.$store.dispatch("matches/fetchById", this.file.match);
            }
        },
        user() {
            return this.$store.getters["user/user"];
        },
        canAddToCollections() {
            const roles = (this.user && this.user.roles) || {};
            return Boolean(roles.archive_collections);
        },
        clipProfileOptions() {
            return [
                { label: "Broadcast MXF source", value: "source" },
                { label: "10Mbs MP4 + deinterlace", value: "standard" },
            ];
        },
        clipProfileBadgeValue() {
            if (this.editEventLive && this.editEventLive.clipProfile) {
                return this.editEventLive.clipProfile;
            }
            if (this.editEventLive && this.editEventLive.clipStatus === "clipping") {
                return this.clipProfile;
            }
            return "";
        },
        clipProfileBadgeLabel() {
            if (!this.clipProfileBadgeValue) return "";
            if (this.clipProfileBadgeValue === "source") return "Profile: Broadcast MXF source";
            return "Profile: 10Mbs MP4 + deinterlace";
        },
        showClipProfileBadge() {
            return Boolean(
                this.editEvent &&
                this.editEvent.source === "user" &&
                this.clipProfileBadgeValue
            );
        },
        isSourceClipFile() {
            return Boolean(
                this.editEventFile &&
                this.editEventFile.sourceExtention === ".mxf"
            );
        },
        showSourceClipPreviewLink() {
            return Boolean(
                this.editEventLive &&
                this.editEventLive.clipped &&
                this.isSourceClipFile &&
                this.editEventFile &&
                this.editEventFile.previewDownloadURL
            );
        },
        showSourceClipPreviewPending() {
            return Boolean(
                this.editEventLive &&
                this.editEventLive.clipped &&
                this.isSourceClipFile &&
                this.editEventFile &&
                !this.editEventFile.previewDownloadURL
            );
        },
        currentClipRequests() {
            const all = this.$store.getters["clippingRequests/array"] || [];
            if (!this.editEvent || !this.editEvent.id) return [];
            return all.filter((req) => req && req.event && req.event.id === this.editEvent.id);
        },
        currentClipRequest() {
            if (!this.currentClipRequests.length) return null;
            const ordered = [...this.currentClipRequests].sort((a, b) => {
                return this.requestCreatedAtMs(b) - this.requestCreatedAtMs(a);
            });
            return ordered[0];
        },
        currentClipRequestProgressPercent() {
            if (!this.currentClipRequest || !this.currentClipRequest.progress) return 0;
            const value = Number(this.currentClipRequest.progress.percent);
            if (!Number.isFinite(value)) return 0;
            return Math.max(0, Math.min(100, Math.round(value)));
        },
        currentEditClipDurationSeconds() {
            if (!this.editEvent) return 0;
            const inPoint = Number(this.tcIn);
            const outPoint = Number(this.tcOut);
            if (!Number.isFinite(inPoint) || !Number.isFinite(outPoint)) return 0;
            return Math.max(0, Math.abs(outPoint - inPoint));
        },
        companySettings() {
            const companyName = this.user && this.user.company;
            if (!companyName) return null;
            return this.$store.getters["companies/byName"](companyName);
        },
        matchType() {
            return this.match && this.match.int ? "international" : "domestic";
        },
        maxClipMinutes() {
            return getMaxClipMinutes(this.companySettings, this.matchType);
        },
        maxClipSeconds() {
            return this.maxClipMinutes * 60;
        },
        isClipDurationOverLimit() {
            return this.currentEditClipDurationSeconds > this.maxClipSeconds;
        },
        isRangeEditLocked() {
            return Boolean(this.editEvent && this.editEventLive && this.editEventLive.clipped);
        },
        timeIn() {
            var date = new Date(null);
            date.setSeconds(this.tcIn); // specify value for SECONDS here
            var result = date.toISOString().substr(11, 8);
            return result;
        },
        timeOut() {
            var date = new Date(null);
            date.setSeconds(this.tcOut); // specify value for SECONDS here
            var result = date.toISOString().substr(11, 8);
            return result;
        },
        displayFields() {
            return this.$store.getters["archiveTemp/displayFields"];
        },
        displayOptions() {
            return this.$store.getters["archiveTemp/displayOptions"];
        },
        collections() {
            return this.$store.getters["collections/array"];
        },
        editEventCollections() {
            if (!this.editEventLive || !Array.isArray(this.editEventLive.collections)) {
                return [];
            }
            return this.editEventLive.collections;
        },
        editEventCollectionNames() {
            return this.editEventCollections
                .map((id) => {
                    const col = this.$store.getters["collections/byId"](id);
                    return (col && col.name) || id;
                })
                .filter(Boolean);
        },
        clipAlreadyInSelectedCollection() {
            if (!this.selectedCollectionId) return false;
            return this.editEventCollections.includes(this.selectedCollectionId);
        },
        playerOptions() {
            const options = {
                controls: true,
                fluid: true,
                preload: "auto",
                html5: { nativeVideoTracks: false, nativeAudioTracks: false },
            };
            if (this.file && this.file.previewDownloadURL) {
                options.sources = [
                    {
                        type: "video/mp4",
                        src: this.file.previewDownloadURL,
                    },
                ];
            }
            return options;
        },
    },

    watch: {
        events: function (newOne) {
            let players = {};
            let teams = {};
            newOne.forEach((clip) => {
                if (clip.batter) players[clip.batter] = true;
                if (clip.bowler) players[clip.bowler] = true;
                if (clip.bookmarkPlayer) players[clip.bookmarkPlayer] = true;
                if (clip.bookmarkTeam) teams[clip.bookmarkTeam] = true;
            });
            // load the players
            players = Object.keys(players);
            players.forEach((player) => {
                let res = this.$store.getters["players/byId"](player);
                if (res === undefined) {
                    this.$store.dispatch("players/fetchById", player);
                }
            });
            // load the teams
            teams = Object.keys(teams);
            teams.forEach((team) => {
                let res = this.$store.getters["teams/byId"](team);
                if (res === undefined) {
                    this.$store.dispatch("teams/fetchById", team);
                }
            });
            this.scheduleTimelineMarkerRender();
        },
        file() {
            this.scheduleTimelineMarkerRender();
        },
        tcIn() {
            this.scheduleTimelineMarkerRender();
        },
        tcOut() {
            this.scheduleTimelineMarkerRender();
        },
    },
    beforeMount() {
        this.$store.dispatch("files/fetchById", this.$route.params.id);
        this.$store.dispatch("collections/fetchAndAdd", { limit: 0 });
        this.$store.dispatch("companies/fetchAndAdd");
        // this.$store.dispatch("files/fetchAndAdd", {
        //   where: [
        //     ["what", "==", "recording"],
        //     ["match", "==", this.match.id],
        //   ],
        // });
        this.$store.dispatch("files/openDBChannel", {
            clauses: { where: [["originalFile", "==", this.$route.params.id]] },
        });
        // this.$store.dispatch("matches/fetchById", "67138");
        this.$store.commit("archiveEvents/RESET_VUEX_EASY_FIRESTORE_STATE");
        this.$store.commit("archiveTemp/clearSelection");
        this.$store
            .dispatch("archiveEvents/fetchAndAdd", {
                clauses: {
                    limit: 1000,
                    where: [["file", "==", this.$route.params.id]],
                },
            })
            .then(async () => {
                // If a direct link to a clip is provided, fetch it explicitly by id
                // so deep linking does not depend on list query timing/limits.
                if (this.$route.params.clip) {
                    try {
                        await this.$store.dispatch("archiveEvents/fetchById", this.$route.params.clip);
                    } catch (e) {
                        // Keep existing behavior for missing docs without crashing render.
                    }
                    var event = this.eventsObj[this.$route.params.clip];
                    if (event) {
                        this.edit(event);
                        this.goToVideoTime(event.tcIn);
                    }
                }
            });
    },
    beforeDestroy() {
        this.$store.dispatch("clippingRequests/closeDBChannel");
        const player = this.currentPlayer();
        if (player) {
            player.off("loadedmetadata", this.scheduleTimelineMarkerRender);
            player.off("durationchange", this.scheduleTimelineMarkerRender);
        }
        this.clearTimelineMarkers();
    },
    methods: {
        currentPlayer() {
            if (!this.$refs.videoPlayer || !this.$refs.videoPlayer.player) return null;
            return this.$refs.videoPlayer.player;
        },
        onPlayerReady(player) {
            if (!player) return;
            player.off("loadedmetadata", this.scheduleTimelineMarkerRender);
            player.off("durationchange", this.scheduleTimelineMarkerRender);
            player.on("loadedmetadata", this.scheduleTimelineMarkerRender);
            player.on("durationchange", this.scheduleTimelineMarkerRender);
            this.scheduleTimelineMarkerRender();
        },
        timelineProgressHolder() {
            const player = this.currentPlayer();
            if (!player || !player.el) return null;
            return player.el().querySelector(".vjs-progress-holder");
        },
        clearTimelineMarkers() {
            const holder = this.timelineProgressHolder();
            if (!holder) return;
            const markers = holder.querySelectorAll(".archive-timeline-marker");
            markers.forEach((marker) => marker.remove());
            const rangeMarkers = holder.querySelectorAll(".archive-timeline-range");
            rangeMarkers.forEach((range) => range.remove());
        },
        markerTitle(event) {
            if (event.bookmark) return event.bookmark;
            if (event.innings && event.over && event.ballNum) {
                return `${event.innings}.${event.over}.${event.ballNum}`;
            }
            if (event.source === "user") return "User clip";
            return "Event";
        },
        markerLabel(event) {
            if (!event) return "";
            if (event.wicket) return "W";
            if (event.extras) return "E";

            const runs = Number(event.runs);
            if (Number.isFinite(runs)) return `${runs}`;
            return "";
        },
        markerClass(event) {
            if (!event) return "";
            if (event.wicket) return "is-wicket";
            if (event.extras) return "is-extras";
            const runs = Number(event.runs);
            if (Number.isFinite(runs)) return "is-runs";
            return "";
        },
        scheduleTimelineMarkerRender() {
            if (this.markerRenderScheduled) return;
            this.markerRenderScheduled = true;
            this.$nextTick(() => {
                this.markerRenderScheduled = false;
                this.renderTimelineMarkers();
            });
        },
        renderTimelineMarkers() {
            const holder = this.timelineProgressHolder();
            const player = this.currentPlayer();
            if (!holder || !player) return;

            this.clearTimelineMarkers();

            const duration = Number(player.duration());
            if (!Number.isFinite(duration) || duration <= 0) return;

            holder.classList.add("archive-progress-holder");
            this.renderCurrentRangeMarker(holder, duration);

            (this.events || []).forEach((event) => {
                const tcIn = Number(event.tcIn);
                if (!Number.isFinite(tcIn) || tcIn < 0) return;
                const position = Math.max(0, Math.min(100, (tcIn / duration) * 100));
                const marker = document.createElement("button");
                marker.type = "button";
                marker.className = "archive-timeline-marker";
                marker.style.left = `${position}%`;
                marker.title = this.markerTitle(event);
                const markerClass = this.markerClass(event);
                if (markerClass) marker.classList.add(markerClass);
                marker.textContent = this.markerLabel(event);
                marker.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.goToVideoTime(tcIn);
                });
                holder.appendChild(marker);
            });
        },
        renderCurrentRangeMarker(holder, duration) {
            const tcIn = Number(this.tcIn);
            const tcOut = Number(this.tcOut);
            if (!Number.isFinite(tcIn) || !Number.isFinite(tcOut)) return;
            if (tcIn < 0 || tcOut < 0) return;

            const start = Math.min(tcIn, tcOut);
            const end = Math.max(tcIn, tcOut);
            const startPercent = Math.max(0, Math.min(100, (start / duration) * 100));
            const endPercent = Math.max(0, Math.min(100, (end / duration) * 100));
            const widthPercent = Math.max(0, endPercent - startPercent);
            if (widthPercent <= 0) return;

            const range = document.createElement("div");
            range.className = "archive-timeline-range";
            range.style.left = `${startPercent}%`;
            range.style.width = `${widthPercent}%`;
            range.title = `In ${start.toFixed(2)}s - Out ${end.toFixed(2)}s`;
            holder.appendChild(range);
        },
        requestCreatedAtMs(request) {
            if (!request || !request.created_at) return 0;
            if (request.created_at.seconds) return request.created_at.seconds * 1000;
            const dt = new Date(request.created_at);
            const ms = dt.getTime();
            return Number.isFinite(ms) ? ms : 0;
        },
        changeField(value, field) {
            this.$store.dispatch("files/patch", {
                id: this.$route.params.id,
                [field]: value,
            });
        },
        displayFieldsSet(value) {
            this.$store.commit("archiveTemp/displayFields", value);
        },
        goToVideoTime(time) {
            const player = this.currentPlayer();
            if (!player) return;
            player.currentTime(time);
        },
        jump(diff) {
            const player = this.currentPlayer();
            if (!player) return;
            const currentTime = Number(player.currentTime()) || 0;
            player.currentTime(currentTime + diff);
        },
        pauseVideo() {
            const player = this.currentPlayer();
            if (!player) return;
            player.pause();
        },
        playVideo(speed) {
            const player = this.currentPlayer();
            if (!player) return;
            player.playbackRate(speed);
            player.play();
        },
        setIn() {
            const player = this.currentPlayer();
            if (!player) return;
            this.tcIn = player.currentTime();
        },
        setOut() {
            const player = this.currentPlayer();
            if (!player) return;
            this.tcOut = player.currentTime();
        },
        updateIn() {
            const player = this.currentPlayer();
            if (!player) return;
            if (this.isRangeEditLocked) return;
            this.tcIn = player.currentTime();
            this.$store.dispatch("archiveEvents/patch", {
                id: this.editEvent.id,
                tcIn: this.tcIn,
                manualSet: true,
            });
        },
        updateOut() {
            const player = this.currentPlayer();
            if (!player) return;
            if (this.isRangeEditLocked) return;
            this.tcOut = player.currentTime();
            this.$store.dispatch("archiveEvents/patch", {
                id: this.editEvent.id,
                tcOut: this.tcOut,
                manualSet: true,
            });
        },
        edit(event) {
            if (!event || !event.id) {
                this.stopEdit();
                return;
            }
            this.selectedCollectionId = "";
            this.editEvent = event;
            this.tcIn = event.tcIn;
            this.tcOut = event.tcOut;
            this.$store.dispatch("archiveEvents/openDBChannel", {
                where: [["id", "==", event.id]],
            });
            const where = [["event.id", "==", event.id]];

            this.$store.dispatch("clippingRequests/openDBChannel", {
                clauses: { where },
            });
        },
        stopEdit() {
            this.editEvent = "";
            this.tcIn = "";
            this.tcOut = "";
            this.selectedCollectionId = "";
            this.$store.dispatch("clippingRequests/closeDBChannel");
        },
        async addToCollection() {
            if (!this.canAddToCollections) return;
            if (!this.editEvent || !this.editEvent.id || !this.selectedCollectionId) return;
            if (this.clipAlreadyInSelectedCollection) {
                this.$notify({
                    type: "info",
                    title: "Already in collection",
                    message: "This clip is already in the selected collection.",
                });
                return;
            }
            this.addingToCollection = true;
            try {
                await this.$store.dispatch("archiveEvents/patch", {
                    id: this.editEvent.id,
                    collections: [...this.editEventCollections, this.selectedCollectionId],
                });
                this.$notify({
                    type: "success",
                    title: "Collection updated",
                    message: "Clip added to collection.",
                });
            } catch (error) {
                this.$notify({
                    type: "danger",
                    title: "Update failed",
                    message:
                        (error && error.message) ||
                        "Could not add this clip to the collection.",
                });
            } finally {
                this.addingToCollection = false;
            }
        },
        buildClipFilename() {
            const f1 = `${this.editEventLive.bookmark} `;
            const f2 = `${this.editEvent.innings}.${this.editEvent.over}.${this.editEvent.ballNum} - `;
            const f3 = `${this.match.team1Name} vs ${this.match.team2Name} - ${this.match.competition} ${this.match.year} - ${this.editEvent.id}`;
            let f = '';
            if (this.editEventLive.bookmark) {
                f = f1;
            }
            if (this.editEvent.innings) {
                f = f + f2;
            }
            return f + f3;
        },
        selectedClipProfile() {
            const allowedProfiles = this.clipProfileOptions.map((option) => option.value);
            return allowedProfiles.includes(this.clipProfile)
                ? this.clipProfile
                : "source";
        },
        clipIt() {
            if (this.isClipDurationOverLimit) {
                return;
            }
            const f = this.buildClipFilename();
            const selectedProfile = this.selectedClipProfile();

            this.$store.dispatch("clippingRequests/insert", {
                file: this.editEvent.file,
                event: this.editEvent,
                filename: f,
                status: "requested",
                clipProfile: selectedProfile,
                created_by: this.user.id,
                created_by_name: this.user.name,
                maxAttempts: 3,
                retryBackoffMs: 5000,
            });
            this.$store.dispatch("archiveEvents/patch", {
                id: this.editEvent.id,
                clipStatus: "clipping",
            });

        },
        changeEvent(event, type) {
            var update = { id: this.editEvent.id };
            update[type] = event;
            console.log(update);
            this.$store.dispatch("archiveEvents/patch", update);
        },
        deleteEvent() {
            this.$store.dispatch("files/delete", this.editEvent.clipFile);
            this.$store.dispatch("archiveEvents/delete", this.editEvent.id);
            this.stopEdit();
        },
        deleteClip() {
            this.$store.dispatch("files/delete", this.editEvent.clipFile);
            this.$store.dispatch("archiveEvents/patch", {
                id: this.editEvent.id,
                clipStatus: "not clipped",
                clipped: false,
                clipSource: "user",
                clipFile: "n/a",
            });
        },
        markIt() {
            let days = this.file.day ? this.file.day : 1; // use a match day if one set
            console.log(this.match)
            var newDate = moment(this.match.startDate).clone().add(days, "days");
            var newDateStr = newDate.format("DD/MM/YYYY");
            let payload = {
                tcIn: this.tcIn,
                tcOut: this.tcOut,
                file: this.fileId,
                match: this.file.match,
                year: this.match.year,
                month: newDate.month() + 1,
                date: newDateStr,
                cricketFormat: this.match.cricketFormat,
                cricketType: this.match.cricketType,
                ground: this.match.ground,
                video: true,
                source: "user",
                username: this.user.name,
            };
            if (this.bookmark) {
                payload.bookmark = this.bookmark;
            }
            if (this.bookmarkPlayer) {
                payload.bookmarkPlayer = this.bookmarkPlayer;
            }
            if (this.bookmarkTeam) {
                payload.bookmarkTeam = this.bookmarkTeam;
            }
            if (this.note) {
                payload.note = this.note;
            }

            this.$store.dispatch("archiveEvents/insert", payload).then((res) => {
                // make this the edited clip
                let obj = this.eventsObj[res];
                this.editEvent = obj;
            });
        },
        reassociate() {
            this.$store.dispatch("files/patch", {
                id: this.$route.params.id,
                what: "archive-awaiting",
            });
        },
        // navigate(id) {
        //   console.log(id)
        //   // window.location.href = "http://echo.ecb.co.uk/#/archive/recording/" + id
        //   // // this.$router.push({ path: '/#/archive/recording/' + id })
        // }
    },
};
</script>

<style scoped>
.viewing-card {
    display: flex;
    /* overflow: hidden; */

}

.viewer {
    flex: 1 1 auto;
}

.archive-video-player {
    width: 100%;
}

::v-deep .archive-video-player .archive-progress-holder {
    position: relative;
}

::v-deep .archive-video-player .archive-timeline-range {
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(45, 206, 137, 0.35);
    border: 1px solid rgba(45, 206, 137, 0.85);
    border-radius: 2px;
    z-index: 1;
    pointer-events: none;
}

::v-deep .archive-video-player .archive-timeline-marker {
    position: absolute;
    top: 50%;
    min-width: 14px;
    height: 14px;
    border: none;
    border-radius: 2px;
    background: #f5365c;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    text-align: center;
    transform: translate(-50%, -50%);
    cursor: pointer;
    padding: 0 2px;
    z-index: 3;
}

::v-deep .archive-video-player .archive-timeline-marker:hover {
    background: #fb6340;
}

::v-deep .archive-video-player .archive-timeline-marker.is-wicket {
    background: #d0021b;
}

::v-deep .archive-video-player .archive-timeline-marker.is-runs {
    background: #2dce89;
}

::v-deep .archive-video-player .archive-timeline-marker.is-extras {
    background: #5e72e4;
}

.events {
    padding-left: 15px;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
}

.event-controls {
    flex: 0 0 auto;
}

.event-list {
    flex: 1 1 0px;
    overflow-y: auto;

}

.bookmarkOption {
    border: none;
}

.clip-progress {
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: #e9ecef;
    overflow: hidden;
}

.clip-progress-fill {
    height: 100%;
    background: #5e72e4;
    transition: width 0.3s ease;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}
</style>
